import Bugsnag from "./bugsnag"

const getCsrfToken = (): string => {
  const metaTag = document.querySelector('meta[name="csrf-token"]')
  if (metaTag instanceof HTMLMetaElement) {
    return metaTag.content
  } else {
    Bugsnag.notify("No meta tag found")
    return ""
  }
}

// Returns the CSRF token header object with the current token value
export const csrfToken = (): Record<string, string> => ({
  "X-CSRF-Token": getCsrfToken(),
})
